import { useNavigate } from 'react-router-dom';
import { TopicForm } from '@/admin/components/TopicForm';

export function TopicCreatePage() {
  const navigate = useNavigate();

  return (
    <TopicForm
      onSuccess={() => navigate('/admin/topics')}
      onCancel={() => navigate('/admin/topics')}
    />
  );
}
